import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

ReactDOM.render(
    <React.StrictMode>
        <div style={{ paddingBottom: "50px" }}>
            <App />
        </div>
    </React.StrictMode>,
    document.getElementById("root")
);
